module.exports = __webpack_public_path__ + "img/3654ee270de04693909f193636357c9a-640.1855146b.jpg";